export const rolesKeys = {
  listAll: ["fetchRoles"],
  byId: id => ["fetchRole", id],
  permissionCategories: ["fetchCategories"]
};
